'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoChatbox = function IoChatbox(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm9.4 31.3c-3.2 0-5.9-2.5-5.9-5.6v-16.3c0-3.1 2.7-5.6 5.9-5.6h20.7c3.2 0 5.9 2.5 5.9 5.6v16.3c0 3.1-2.7 5.6-5.9 5.6h-0.3v5s-6.2-4.3-6.8-4.7-0.5-0.3-1.6-0.3h-12z' })
        )
    );
};

exports.default = IoChatbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/chatbox.js
// module id = 2007
// module chunks = 0